module.exports = __webpack_public_path__ + "static/media/pd-intro.b584f787.mp3";